import { getUserId } from "@/services/supabase/auth/actions/getUserId";
import { supabase } from "@/services/supabase/createClient";
import { UserSettings } from "../types";

export const updateUserSettings = async (settings: UserSettings) => {
  const userId = await getUserId();
  await supabase.rpc("update_user_settings", { p_user_id: userId, p_settings: settings as any });
};
